import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'
import { TransitionGroup } from 'react-transition-group'

import ScrollToTop from '../components/ScrollToTop'
import { FadeAbsolutePage } from '../components/Transitions'

import Home from '../pages/Home'
import Generic from '../pages/Generic'
import Trainingen from '../pages/Trainingen'
import Training from '../pages/Training'
import FeedStylePage from '../pages/FeedStylePage'
import Offerte from '../pages/Offerte'
import Menu from './Menu'
import Loader from '../components/Loader'

class App extends Component {
    render() {
        return (
            <div>
                <Loader />
                <Route component={Menu} />
                <Route render={({location}) => {
                    const theArr = location.pathname.split('/')
                    const theKey = theArr[1] === 'klanten' || theArr[1] === 'taqtici' ? theArr[1] : location.pathname
                    return (
                        <TransitionGroup className="transition-wrap-page">
                            <FadeAbsolutePage key={theKey}>
                                <ScrollToTop>
                                    <Switch location={location}>
                                        <Route exact path="/" component={Home}/>
                                        <Route exact path="/trainingen" component={Trainingen}/>
                                        <Route path="/trainingen/:id" component={Training}/>
                                        <Route path="/klanten" component={FeedStylePage}/>
                                        <Route path="/taqtici" component={FeedStylePage}/>
                                        <Route path="/:id" component={Generic} /> 
                                    </Switch>
                                </ScrollToTop>
                            </FadeAbsolutePage>
                        </TransitionGroup>
                    )
                }}/>
                <Route component={Offerte} />
            </div>
		)
    }
}

// const HashRoute = ({ component: Component, path, ...routeProps }) => (
//   <Route {...routeProps} component={({ location, ...props }) => location.hash === path && <Component {...props} />} />
// )


export default App


// WEBPACK FOOTER //
// ./src/containers/App.js